import React from "react";

const FormError = (props) => {
  if (!props.error) return null;
  return (
    <div className="FormError">
      <p>{props.error}</p>
    </div>
  )
}

export default FormError;